export interface Video {
  id: string;
  title: string;
  thumbnail: string;
  published_at: string;
  duration_seconds: number;
  type: string;
  url: string;
}

export interface VideoPayload {
  selectedVideoId: string;
}

export type VideoCache = {
  videos: Video[];
  pageToken: string;
};

export enum VideoType {
  VIDEOS = 'video',
  SHORTS = 'short',
  ALL = 'all',
}
